import { Moon, Sun } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import { useTheme } from "@/stores/theme-provider";

/**
 * ThemeToggle — Phase 6a.2 per spec §9.2; i18n wired in 6a.6.
 *
 * Ghost icon button that toggles light ↔ dark via the custom ThemeProvider.
 * Tailwind `dark:` variants swap the visible icon (Sun in light, Moon in
 * dark) so a single click flips both the class and the icon.
 */
export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const { t } = useTranslation();
  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
      aria-label={t("theme.toggle")}
    >
      <Sun className="h-5 w-5 dark:hidden" />
      <Moon className="hidden h-5 w-5 dark:block" />
    </Button>
  );
}
